import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "gatsby";

function Tag({ name, to, isCategory }) {
  const linkClassName = classNames("tag", { "tag--category": isCategory });

  return (
    <li>
      <Link className={linkClassName} to={to}>
        {name}
      </Link>
    </li>
  );
}

Tag.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
};

export default Tag;
